<template>
  <form class="keepmeposted">
    <input
      v-model="$v.emailto.$model"
      type="email"
      name="text"
      aria-label="Mail to"
      :readonly="loading"
      class="input keepmeposted__input"
      :class="{
        error: $v.emailto.$error && emailto,
        succes: !$v.emailto.$error && $v.emailto.$model,
      }"
      :placeholder="this.$t('placeholder.email')"
      @input="setDelay($v.emailto)"
    />
    <button class="button_primary keepmeposted__button" :disabled="loading" @click.prevent="send">
      {{ !loading ? $t('form.send') : '' }}
      <HSpinner v-show="loading" size="small"></HSpinner>
    </button>
    <span
      v-show="$v.emailto.$error && emailto"
      class="text__danger text__small_content text__left_aligment"
    >
      {{ $t('form.error.email') }}
    </span>
  </form>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import { HSpinner } from 'vue-haichi'

const touchMap = new WeakMap()

export default {
  name: 'KeepMePosted',
  components: {
    HSpinner,
  },
  data() {
    return {
      emailto: '',
      loading: false,
    }
  },
  validations: {
    emailto: {
      required,
      minLength: minLength(4),
      email,
    },
  },
  methods: {
    setDelay($v) {
      $v.$reset()
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v))
      }
      touchMap.set($v, setTimeout($v.$touch, 1000))
    },
    send() {
      this.$v.$touch()
      if (this.$v.$anyError) return
      // eslint-disable-next-line no-undef
      grecaptcha.ready(async () => {
        try {
          // eslint-disable-next-line no-undef
          const recaptchaToken = await grecaptcha.execute(process.env.VUE_APP_SITEKEY, {
            action: 'keepMePosted',
          })
          this.submitInfo(recaptchaToken)
        } catch (error) {
          console.error(error)
          this.$toast.error(this.$t('form.error.toast'), [], 3000)
        }
      })
    },
    async submitInfo(recaptchaToken) {
      this.$v.$touch()
      if (this.$v.$anyError || !recaptchaToken) {
        return
      }
      const formData = new FormData()
      formData.append('email', this.emailto)
      formData.append('token', recaptchaToken)
      this.loading = true
      try {
        const { status } = await this.axios.post(process.env.VUE_APP_SCRIPTURL_KMP, formData)
        if (status === 200) {
          this.emailto = ''
          this.$toast.success(this.$t('form.success'), [], 3000)
        } else {
          this.$toast.error(this.$t('form.error.toast'), [], 3000)
        }
      } catch (error) {
        console.error(error)
        this.$toast.error(this.$t('form.error.toast'), [], 3000)
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.keepmeposted {
  display: grid;
  grid-template-columns: auto 150px;
  width: 440px;
  height: 48px;
  margin-right: auto;
  margin-left: auto;
  &__input {
    border-radius: 5px 0px 0px 5px;
    border: 2px solid #f3f3f3;
    border-bottom-width: 2px;
    border-right-width: 0;
    &:focus {
      border-color: #2a7dd6;
    }

    &:active {
      border-color: #2a7dd6;
    }
  }

  &__button {
    border-radius: 0px 5px 5px 0px;
    border: 2px solid #2a7dd6;
    &:hover {
      border-radius: 0px 5px 5px 0px;
    }
  }
}

.error {
  border-color: #dd4c41;
}
.sucess {
  border-color: #20e4e1;
}

@media only screen and (max-width: 768px) {
  .keepmeposted {
    display: flex;
    flex-flow: column;
    grid-template-columns: unset;
    width: 100%;
    height: 108px;
    &__input {
      border-radius: 5px 5px 0px 0px;
      border-bottom-width: 0;
      border-right-width: 2px;
    }

    &__button {
      border-radius: 0px 0px 5px 5px;
      &:hover {
        border-radius: 0px 0px 5px 5px;
      }
    }
  }
}
</style>
